import {Redirect} from 'expo-router';
import {useSession} from "@/lib/auth/auth";

export default function Index() {
    const {session} = useSession();
    if (!!session) {
        console.log("Redirecting because of", session)
        return <Redirect href="/u/account"/>;
    } else {
        console.log("Redirecting to login")
        return <Redirect href="/u/account/login"/>;
    }
}